export default "__VITE_ASSET__D8ECz$KL__"